import React, { Component } from "react";
import ReactTooltip from "react-tooltip";
import { Link } from "react-router-dom";
import JejakinLogo from "./../../../gogreener_adoptree_jejakin.svg";
import ErrorVector from "./../../../images/offline.svg";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import jjk_planting from "./../../../images/superhero.svg";
import icon_tree from "./../../../images/icon/tree.png";
import icon_info from "./../../../images/icon/info.svg";
import icon_sun from "./../../../images/icon/sun.svg";
import icon_cstock from "./../../../images/icon/icon_cstock.svg";
import icon_jejak from "./../../../images/icon/jejak.png";
import icon_2023 from "./../../../images/icon/2023.svg";
import icon_2023_disabled from "./../../../images/icon/2023-disabled.svg";
import icon_2024 from "./../../../images/icon/2024.svg";
import icon_2024_disabled from "./../../../images/icon/2024-disabled.svg";
import icon_2025 from "./../../../images/icon/2025.svg";
import icon_2025_disabled from "./../../../images/icon/2025-disabled.svg";
import icon_2026 from "./../../../images/icon/2026.svg";
import icon_2026_disabled from "./../../../images/icon/2026-disabled.svg";
import icon_2030 from "./../../../images/icon/2030.svg";
import icon_2030_disabled from "./../../../images/icon/2030-disabled.svg";

import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import NumberFormat from "react-number-format";
import axios from "axios";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./Profile.scss";
import ContentLoader from "react-content-loader";
import { Translation } from "react-i18next";
import ProgramArea from "./ProgramArea";
import ProgramMapArea from "./ProgramMapArea";

import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Pagination } from "swiper";
import "swiper/swiper.scss";
import "swiper/components/pagination/pagination.scss";
SwiperCore.use([Pagination]);

// https://github.com/lucasmogari/google-map-react-example
// Google Map Polygon

// Map Open Layer
// https://dominoc925.blogspot.com/2019/10/simple-example-of-reactjs-and.html

const CardLoaderFull = () => (
  <ContentLoader height={170}>
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="140" />
  </ContentLoader>
);

const CardLoaderBox = () => (
  <ContentLoader height={120}>
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="100" />
  </ContentLoader>
);

const CardLoader = () => (
  <ContentLoader height={320}>
    <rect x="0" y="0" rx="6" ry="6" width="100%" height="220" />
    <rect x="0" y="230" rx="6" ry="6" width="300" height="12" />
    <rect x="0" y="250" rx="6" ry="6" width="300" height="16" />
    <rect x="0" y="275" rx="6" ry="6" width="50" height="12" />
  </ContentLoader>
);

function SeparatorNumber(lang, number, decimal) {
  if (lang === "en") {
    return (
      <React.Fragment>
        <NumberFormat
          value={number}
          displayType={"text"}
          thousandSeparator={","}
          decimalSeparator={"."}
          decimalScale={decimal}
          className="black"
        />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <NumberFormat
          value={number}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          decimalScale={decimal}
          className="black"
        />
      </React.Fragment>
    );
  }
}

function SeparatorValue(lang, value) {
  // return <GuestGreeting / > ;
  var val;
  if (value >= 1000000) {
    val = value / 1000000;
  } else if (value >= 9999.999 && value < 1000000) {
    val = value / 1000;
  } else {
    val = value;
  }
  if (lang === "en") {
    if (value >= 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={","}
            decimalSeparator={"."}
            decimalScale={1}
          />
        </React.Fragment>
      );
    } else if (value >= 9999.999 && value < 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={","}
            decimalSeparator={"."}
            decimalScale={0}
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={","}
            decimalSeparator={"."}
            decimalScale={0}
          />
        </React.Fragment>
      );
    }
  } else {
    if (value >= 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            decimalScale={1}
          />
        </React.Fragment>
      );
    } else if (value >= 9999.999 && value < 1000000) {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            decimalScale={0}
          />
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
          <NumberFormat
            value={val}
            displayType={"text"}
            thousandSeparator={"."}
            decimalSeparator={","}
            decimalScale={0}
          />
        </React.Fragment>
      );
    }
  }
}
function UnitValue(lang, value) {
  if (lang === "en") {
    if (value <= 9999.999) {
      return "Grams";
    } else if (value <= 1000000) {
      return "Kg";
    } else {
      return "Tonnes";
    }
  } else {
    if (value <= 9999.999) {
      return "Gram";
    } else if (value <= 1000000) {
      return "Kg";
    } else {
      return "Ton";
    }
  }
}

function convertToDate(dateValue) {
  const dateObject = new Date(dateValue);
  const day = dateObject.getDate();
  const month = dateObject.toLocaleString("default", { month: "short" });
  const year = dateObject.getFullYear();

  return `${day} ${month} ${year}`;
}
class ProfileProgramContributionAdoption extends Component {
  constructor(props) {
    super(props);
    this.map = {};
    this.state = {
      status: true,
      loggedIn: false,
      error: null,
      loaderButton: false,
      loading: true,
      loadingMap: true,
      userid: null,
      programid: null,
      user: {},
      cstock: {},
      treeGrowth: [],
      treeGrowthCarbon: [],
      lang: "en",
      programDetail: {},
      programGeneral: {},
      programImages: [],
      bounds: null,
      blockProgram: null,
      blockProgramName: null,
      blockArea: 0,
      showingInfoWindow: false,
      activeMarker: {},
      selectedPlace: {},
      listProgramTreeSummary: [],
      center: {
        lat: -6.2731154,
        lng: 106.723221,
      },
      zoom: 11,
      loc_id: null,
      date: null,
      type: "drone",
      id_group: 1,
      hide_else: false,
      weather: null,
      adopted_trees: [],
      droneId: null,
      // droneSummary: {},
      layer_type: this.props.layer_type,
    };
  }

  componentDidMount() {
    this.setState({
      lang: window.localStorage.i18nextLng,
      userid: this.props.match.params.idprofile,
      programid: this.props.match.params.idprogram,
    });
    this.getDroneContainer(this.props.match.params.idprogram);
    //this.getDroneSummary(this.props.match.params.idprogram);
    this.getBlockProgram();
    this.getTransactionDetail(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getTransactionCstockDetail(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getProgramDetail(
      this.props.match.params.idprogram,
      this.props.match.params.idprofile
    );
    this.getAnnualTreeGrowthDiameter(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getAnnualTreeGrowthCarbon(
      this.props.match.params.idprofile,
      this.props.match.params.idprogram
    );
    this.getTrees(
      this.props.match.params.idprogram,
      this.props.match.params.idprofile
    );
    this.getWeather(this.props.match.params.idprogram);
    // this.getDroneLayer(this.props.match.params.idprogram, this.props.match.params.idprofile)
  }

  getDroneContainer = (idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST + "/profile/drone-container/" + idprogram
      )
      .then((res) => {
        if (res.data.status) {
          console.log("drone container", res.data);
          if (res.data.data.droneList.length !== 0) {
            //console.log("droneId not null");
            this.setState({
              droneId: res.data.data.droneList[0].id,
              loadingMap: false,
            });
          } else {
            console.log("droneId null");
            this.setState({
              droneId: null,
              loadingMap: false,
            });
          }
        }
      });
  };
  // getDroneSummary = (idprogram) => {
  //   axios
  //     .get(
  //       process.env.REACT_APP_API_HOST + "/profile/drone-summary/" + idprogram
  //     )
  //     .then((res) => {
  //       if (res.data.status) {
  //         console.log("drone summary", res.data);
  //         this.setState({
  //           droneSummary: res.data.data,
  //           loading: false,
  //         });
  //       }
  //     });
  // };
  getTransactionDetail = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/transactions-summary/" +
          idprofile +
          "/" +
          idprogram
      )
      .then((res) => {
        if (res.data.status) {
          this.setState({
            user: res.data.data,
          });
        }
      });
  };
  getAnnualTreeGrowthDiameter = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/annual-tree-diameter/" +
          idprofile +
          "/" +
          idprogram
      )
      .then(
        (res) => {
          if (res.data.status) {
            console.log("res annual tree diameter ", res.data);
            this.setState({
              treeGrowth: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };
  getAnnualTreeGrowthCarbon = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/annual-tree-carbon/" +
          idprofile +
          "/" +
          idprogram
      )
      .then(
        (res) => {
          if (res.data.status) {
            console.log("res annual tree carbon ", res.data);
            this.setState({
              treeGrowthCarbon: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };

  getTransactionCstockDetail = (idprofile, idprogram) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/profile/transactions-cstock/" +
          idprofile +
          "/" +
          idprogram
      )
      .then(
        (res) => {
          if (res.data.status) {
            console.log("res cstock detail ", res.data);
            this.setState({
              cstock: res.data.data,
            });
          } else {
            this.setState({
              errorState: true,
              errors: res.data.errors,
            });
          }
        },
        (error) => {
          console.log("error", error);
          setTimeout(() => {
            this.setState({
              errorState: true,
              errors: error.response.data.errors,
            });
          }, 1000);
        }
      );
  };

  getProgramDetail = (idprogram, idprofile) => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/program/detail/" +
          idprogram +
          "/" +
          idprofile
      )
      .then((res) => {
        console.log("res program ", res.data);
        if (res.data.status) {
          this.setState(
            {
              programDetail: res.data.data,
              programImages: res.data.data.programImages,
              listProgramTreeSummary: res.data.data.listProgramTreeSummary,
            },
            () => {
              this.getProgramGeneral(idprogram);
            }
          );
        }
      });
  };

  getTrees = (idprogram, idprofile) => {
    console.log("program id ", idprogram);
    console.log("profile id ", idprofile);
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/tree/collected/" +
          idprogram +
          "/" +
          idprofile
      )
      .then((res) => {
        console.log("adopted trees list ", res.data.data);
        if (res.data.status) {
          this.setState({
            adopted_trees: res.data.data,
          });
        }
      });
  };

  getWeather = (idprogram) => {
    axios
      .get(process.env.REACT_APP_API_HOST + "/program/weather/" + idprogram)
      .then((res) => {
        if (res.data.status) {
          this.setState({
            weather: res.data.data,
          });
        } else {
        }
      });
  };

  getProgramGeneral = (idprogram) => {
    axios
      .get(process.env.REACT_APP_API_HOST + "/program/general/" + idprogram)
      .then((res) => {
        if (res.data.status) {
          this.setState({
            programGeneral: res.data.data,
            loading: false,
          });
        }
      });
  };

  getBlockProgram = () => {
    axios
      .get(
        process.env.REACT_APP_API_HOST +
          "/program/block/" +
          this.props.match.params.idprogram
      )
      .then((res) => {
        if (res.data.status) {
          console.log("blok program", res.data);
          this.setState({
            blockProgram: res.data.data[0].coordinate,
            blockProgramName: res.data.data[0].name,
            blockArea: res.data.data[0].area,
          });
        }
      });
  };

  openTreeDetail = (treeid) => {
    window.location =
      "/profile/" +
      this.props.match.params.idprofile +
      "/" +
      treeid +
      "/tree-history";
  };

  openSensorData = () => {
    window.location =
      "/profile/" +
      this.props.match.params.idprofile +
      "/" +
      this.props.match.params.idprogram +
      "/sensor";
  };

  render() {
    const { treeGrowth, treeGrowthCarbon } = this.state;
    return (
      <>
        <div className="header no-print">
          <div className="nav nav-main-top">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <div className="logo-img">
                    <img src={JejakinLogo} alt="Jejak.in" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mpl-page">
          {this.state.errorState ? (
            <>
              <div className="modal-error active">
                <div className="modal">
                  <span
                    className="modal-close"
                    onClick={() => {
                      this.setState({
                        errorState: false,
                        errors: null,
                      });
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className="h-6 w-6"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </span>
                  <div className="modal-content">
                    <img src={ErrorVector} alt="Error" className="mb-20" />
                    <h3 className="tx-center">
                      <Translation>
                        {(t, { i18n }) => <>{t(this.state.errors[0].code)}</>}
                      </Translation>
                    </h3>
                  </div>
                </div>
              </div>
            </>
          ) : null}
          <ToastContainer />
          {this.state.loading ? (
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <br />
                  <br />
                  <CardLoaderFull />
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <CardLoaderBox />
                  <br />
                </div>
                <div className="col-12">
                  <CardLoaderBox />
                  <br />
                </div>
                <div className="col-12">
                  <CardLoaderBox />
                </div>
              </div>
              <br />
              <div className="row">
                <div className="col-12">
                  <CardLoader />
                </div>
              </div>
            </div>
          ) : (
            <Translation>
              {(t, { i18n }) => (
                <div className="container">
                  <div className="row">
                    <div className="col-12">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link
                            to={"/profile/" + this.props.match.params.idprofile}
                          >
                            {t("Report")}
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          <span>{t("ReportDetail")}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="card card-custom">
                        <div className="text-card">
                          <h4>
                            {t("Hi")}{" "}
                            <span className="tx-capitalize">
                              {this.state.user.userName}
                            </span>
                          </h4>
                          <p className="text-overview mb-0">
                            {t("WeHaveTaggedYourTrees")}
                          </p>
                          <p className="text-overview mb-0 mt-2">
                            {t("ThisIsTheTreePlantingProgramReport")}
                          </p>
                        </div>
                        <img
                          src={jjk_planting}
                          className="img-float"
                          alt="GoGreener"
                        />
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-sm-12">
                      <h2 className="title-page mt-0 mb-0">
                        {this.state.programDetail.title}
                      </h2>
                      <div className="wrapper-slide">
                        {this.state.programImages.length !== 0 ? (
                          <>
                            <Swiper
                              pagination={{ clickable: true }}
                              spaceBetween={5}
                              centeredSlides={true}
                              onSwiper={(swiper) =>
                                console.log("Onboarding loaded")
                              }
                            >
                              <SwiperSlide key={"FEATUREDIMAGE"}>
                                <div className="swiper-slide swiper-radius small">
                                  <div className="img-wrap">
                                    <LazyLoadImage
                                      effect="blur"
                                      src={
                                        process.env.REACT_APP_IMAGE_PROGAM +
                                        "/image/program/" +
                                        this.state.programDetail.featuredImage
                                      }
                                      className="img-responsive rad-10"
                                      alt={this.state.programDetail.title}
                                    />
                                  </div>
                                </div>
                              </SwiperSlide>
                              {this.state.programImages.map((img, idx) => {
                                return (
                                  <SwiperSlide key={img}>
                                    <div className="swiper-slide swiper-radius small">
                                      <div className="img-wrap">
                                        <LazyLoadImage
                                          effect="blur"
                                          src={
                                            process.env.REACT_APP_IMAGE_PROGAM +
                                            "/image/program/" +
                                            img
                                          }
                                          className="img-responsive rad-10"
                                          alt="Program Images"
                                        />
                                      </div>
                                    </div>
                                  </SwiperSlide>
                                );
                              })}
                            </Swiper>
                          </>
                        ) : (
                          <div className="swiper-slide swiper-radius small">
                            <div className="img-wrap">
                              <img
                                src={
                                  process.env.REACT_APP_IMAGE_PROGAM +
                                  "/image/program/" +
                                  this.state.programDetail.featuredImage
                                }
                                className="img-responsive rad-10"
                                alt=""
                              />
                            </div>
                          </div>
                        )}
                      </div>
                      <h3>{t("MyProgramContributions")}</h3>
                      {/* <div className='card card-white'>
                                    <div className='card-icon'>
                                       <div className='icon'>
                                          <img src={icon_jejak} alt='Tree' />
                                       </div>
                                       <div className='text'>
                                          <h4 className='contribution'>
                                             {SeparatorValue(
                                                this.state.lang,
                                                this.state.user.totalCarbon *
                                                   1000000
                                             )}{" "}
                                             {UnitValue(
                                                this.state.lang,
                                                this.state.user.totalCarbon *
                                                   1000000
                                             )}
                                          </h4>
                                          <span className='estimated-carbon'>
                                             {t("EstimatedCarbonStock")}
                                          </span>
                                       </div>
                                    </div>
                                    <div className='card-icon'>
                                       <div className='icon'>
                                          <img src={icon_tree} alt='Tree' />
                                       </div>
                                       <div
                                          className='text'
                                          style={{ paddingBottom: "0" }}
                                       >
                                          <h4 className='contribution'>
                                             {this.state.lang === "id" ? (
                                                <React.Fragment>
                                                   {this.state.user.totalTree >=
                                                      0 &&
                                                   this.state.user.totalTree <=
                                                      0.0099 ? (
                                                      <NumberFormat
                                                         value={
                                                            this.state.user
                                                               .totalTree
                                                         }
                                                         displayType={"text"}
                                                         thousandSeparator={"."}
                                                         decimalSeparator={","}
                                                         decimalScale={3}
                                                      />
                                                   ) : (
                                                      <React.Fragment>
                                                         {this.state.user
                                                            .totalTree >
                                                            0.009 &&
                                                         this.state.user
                                                            .totalTree <=
                                                            0.94 ? (
                                                            <NumberFormat
                                                               value={
                                                                  this.state
                                                                     .user
                                                                     .totalTree
                                                               }
                                                               displayType={
                                                                  "text"
                                                               }
                                                               thousandSeparator={
                                                                  "."
                                                               }
                                                               decimalSeparator={
                                                                  ","
                                                               }
                                                               decimalScale={2}
                                                            />
                                                         ) : (
                                                            <NumberFormat
                                                               value={
                                                                  this.state
                                                                     .user
                                                                     .totalTree
                                                               }
                                                               displayType={
                                                                  "text"
                                                               }
                                                               thousandSeparator={
                                                                  "."
                                                               }
                                                               decimalSeparator={
                                                                  ","
                                                               }
                                                               decimalScale={1}
                                                            />
                                                         )}
                                                      </React.Fragment>
                                                   )}
                                                </React.Fragment>
                                             ) : (
                                                <React.Fragment>
                                                   {this.state.user.totalTree >=
                                                      0 &&
                                                   this.state.user.totalTree <=
                                                      0.0099 ? (
                                                      <NumberFormat
                                                         value={
                                                            this.state.user
                                                               .totalTree
                                                         }
                                                         displayType={"text"}
                                                         thousandSeparator={","}
                                                         decimalSeparator={"."}
                                                         decimalScale={3}
                                                      />
                                                   ) : (
                                                      <React.Fragment>
                                                         {this.state.user
                                                            .totalTree >
                                                            0.009 &&
                                                         this.state.user
                                                            .totalTree <=
                                                            0.94 ? (
                                                            <NumberFormat
                                                               value={
                                                                  this.state
                                                                     .user
                                                                     .totalTree
                                                               }
                                                               displayType={
                                                                  "text"
                                                               }
                                                               thousandSeparator={
                                                                  ","
                                                               }
                                                               decimalSeparator={
                                                                  "."
                                                               }
                                                               decimalScale={2}
                                                            />
                                                         ) : (
                                                            <NumberFormat
                                                               value={
                                                                  this.state
                                                                     .user
                                                                     .totalTree
                                                               }
                                                               displayType={
                                                                  "text"
                                                               }
                                                               thousandSeparator={
                                                                  ","
                                                               }
                                                               decimalSeparator={
                                                                  "."
                                                               }
                                                               decimalScale={1}
                                                            />
                                                         )}
                                                      </React.Fragment>
                                                   )}
                                                </React.Fragment>
                                             )}{" "}
                                             {t("Trees")}
                                          </h4>
                                          <span className='contribution'>
                                             {t("contribution")}
                                          </span>
                                       </div>
                                    </div>
                                 </div> */}

                      <div
                        className="card card-white"
                        style={{ marginBottom: "30px" }}
                      >
                        <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {t("contribution")}
                            </span>
                            <h4 className="black">
                              {SeparatorNumber(
                                this.state.lang,
                                this.state.user.totalContribution,
                                2
                              )}{" "}
                              {t("Transactions")}
                            </h4>
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {t("Adopted")}
                            </span>
                            <h4 className="black">
                              {SeparatorNumber(
                                this.state.lang,
                                this.state.user.totalTreeAdoption,
                                2
                              )}{" "}
                              {t("Trees")}
                            </h4>
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_cstock} alt="Sequestration" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {this.state.cstock.lastDate === null
                                ? t("EstimatedCstokAfterTreePlanted")
                                : t("EstimatedCstokAfterDate", {
                                    date: convertToDate(
                                      this.state.cstock.lastDate
                                    ),
                                  })}
                            </span>
                            <h4 className="black">
                              {SeparatorNumber(
                                this.state.lang,
                                this.state.cstock.totalLastDateCarbonEmission,
                                2
                              )}
                              &nbsp;
                              {
                                this.state.cstock
                                  .totalLastDateCarbonEmissionUnit
                              }
                            </h4>
                          </div>
                          <div className="ml-1">
                            <div style={{ position: "relative" }}>
                              <img
                                src={icon_info}
                                data-tip
                                data-for="tooltip"
                                alt="tooltip"
                                width={"18px"}
                                height={"18px"}
                                style={{ position: "absolute", top: "2px" }}
                              />
                            </div>

                            <ReactTooltip
                              className="tooltip"
                              id="tooltip"
                              place="left"
                              type="dark"
                              effect="solid"
                              getContent={() => t("Estimatedcarbonstockdesc")}
                              arrow="center"
                            />
                          </div>
                        </div>
                        {/* <div className="card-icon">
                          <div className="icon mr-2">
                            <img src={icon_cstock} alt="Sequestration" />
                          </div>
                          <div className="text">
                            <span className="note contribution">
                              {t("EstimatedCstok8Lifespan")}
                            </span>
                            <h4 className="black">
                              {SeparatorNumber(
                                this.state.lang,
                                this.state.cstock.totalCarbonEmissionLifespan,
                                2
                              )}
                              &nbsp;
                              {
                                this.state.cstock
                                  .totalCarbonEmissionLifespanUnit
                              }
                            </h4>
                          </div>
                        </div> */}
                      </div>

                      <h3>{t("SensorData")}</h3>
                      <div className="card card-white">
                        <div className="card-icon">
                          <div className="icon">
                            <img src={icon_sun} alt="Sun" />
                          </div>
                          <div className="text text-single">
                            <h4 className="temperature">
                              {this.state.weather ? (
                                <>
                                  {SeparatorNumber(
                                    this.state.lang,
                                    this.state.weather.main.temp,
                                    2
                                  )}{" "}
                                  <sup>o</sup> C
                                </>
                              ) : (
                                <>
                                  N/A <sup>o</sup> C{" "}
                                </>
                              )}
                            </h4>
                            <span className="temperature">
                              {t("Temperature")}
                            </span>
                          </div>
                          <div className="button-wrap">
                            <Link
                              to={
                                "/profile/" +
                                this.props.match.params.idprofile +
                                "/" +
                                this.props.match.params.idprogram +
                                "/sensor?program=adoption"
                              }
                              className="button"
                            >
                              {t("seedetail")}
                            </Link>
                          </div>
                        </div>
                      </div>

                      <h3>{t("MyAdoptedTrees")}</h3>
                      <div className="row">
                        {this.state.adopted_trees.map((tr) => {
                          return (
                            <div className="col-12 col-sm-6" key={tr.id}>
                              <div
                                className="box-item box-th"
                                style={
                                  tr.treeHistoryId
                                    ? null
                                    : { cursor: "not-allowed" }
                                }
                              >
                                <div className="bi-img">
                                  <Link
                                    to={
                                      tr.treeHistoryId
                                        ? "/profile/" +
                                          this.props.match.params.idprofile +
                                          "/" +
                                          tr.treeHistoryId +
                                          "/tree-adoption"
                                        : "#"
                                    }
                                    style={
                                      tr.treeHistoryId
                                        ? null
                                        : { pointerEvents: "none" }
                                    }
                                  >
                                    {tr.id ? (
                                      <img
                                        src={
                                          process.env.REACT_APP_TREE_QUERY +
                                          "/tree/" +
                                          tr.id +
                                          "/image"
                                        }
                                        alt={"Tree Species"}
                                        style={{
                                          cursor: "pointer",
                                        }}
                                      />
                                    ) : (
                                      <svg
                                        width="156"
                                        height="100"
                                        viewBox="0 0 156 100"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M0 0H156V100H0V0Z"
                                          fill="#8DDD97"
                                        />
                                        <path
                                          fill-rule="evenodd"
                                          clip-rule="evenodd"
                                          d="M79.3334 23.3333C81.5425 23.3333 83.3334 25.1526 83.3334 27.3968C83.3334 29.0636 84.0201 31.0031 85.731 32.564C87.4241 34.1086 90.4015 35.5238 95.3334 35.5238C97.5425 35.5238 99.3334 37.3431 99.3334 39.5873C99.3334 41.8315 97.5425 43.6508 95.3334 43.6508C90.5781 43.6508 86.6041 42.6312 83.4592 40.838C83.7264 42.1719 84.4347 43.5719 85.731 44.7545C87.4241 46.2991 90.4015 47.7143 95.3334 47.7143C97.5425 47.7143 99.3334 49.5336 99.3334 51.7778C99.3334 54.022 97.5425 55.8413 95.3334 55.8413C90.5781 55.8413 86.6041 54.8217 83.4592 53.0284C83.7264 54.3624 84.4347 55.7623 85.731 56.945C87.4241 58.4896 90.4015 59.9048 95.3334 59.9048C97.5425 59.9048 99.3334 61.724 99.3334 63.9683C99.3334 66.2125 97.5425 68.0317 95.3334 68.0317C90.5145 68.0317 86.4979 66.9847 83.3334 65.1465V74.6349C83.3334 75.757 82.4379 76.6667 81.3334 76.6667H77.3334C76.2288 76.6667 75.3334 75.757 75.3334 74.6349V65.1465C72.1689 66.9847 68.1523 68.0317 63.3334 68.0317C61.1242 68.0317 59.3334 66.2125 59.3334 63.9683C59.3334 61.724 61.1242 59.9048 63.3334 59.9048C68.2653 59.9048 71.2426 58.4896 72.9357 56.945C74.232 55.7623 74.9403 54.3624 75.2076 53.0284C72.0626 54.8217 68.0886 55.8413 63.3334 55.8413C61.1242 55.8413 59.3334 54.022 59.3334 51.7778C59.3334 49.5336 61.1242 47.7143 63.3334 47.7143C68.2653 47.7143 71.2426 46.2991 72.9357 44.7545C74.232 43.5719 74.9403 42.1719 75.2076 40.838C72.0626 42.6312 68.0886 43.6508 63.3334 43.6508C61.1242 43.6508 59.3334 41.8315 59.3334 39.5873C59.3334 37.3431 61.1242 35.5238 63.3334 35.5238C68.2653 35.5238 71.2426 34.1086 72.9357 32.564C74.6467 31.0031 75.3334 29.0636 75.3334 27.3968C75.3334 25.1526 77.1242 23.3333 79.3334 23.3333Z"
                                          fill="#3BA749"
                                        />
                                      </svg>
                                    )}
                                  </Link>
                                </div>
                                <div className="bi-text">
                                  <h2 className="tx-capitalize">{tr.name}</h2>
                                  <div className="text-ellipsis">
                                    <span
                                      className="tx-capitalize display-block"
                                      style={{
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      {tr.binomialName}
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>

                      <h3>{t("ProgramInformation")}</h3>
                      <div className="program-information-wrap">
                        <div
                          className="program-content-wrap"
                          dangerouslySetInnerHTML={{
                            __html: this.state.programDetail.description,
                          }}
                        ></div>
                      </div>
                    </div>
                    <div className="col-sm-12">
                      <br />
                      <div className="card card-green">
                        <div className="card-icon">
                          <div className="icon">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <h4>
                              {this.state.lang === "id" ? (
                                <React.Fragment>
                                  {this.state.programGeneral.totalArea >
                                  10000 ? (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea /
                                        10000
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={0}
                                    />
                                  ) : (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={0}
                                    />
                                  )}
                                </React.Fragment>
                              ) : (
                                <React.Fragment>
                                  {this.state.programGeneral.totalArea >
                                  10000 ? (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea /
                                        10000
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={0}
                                    />
                                  ) : (
                                    <NumberFormat
                                      value={
                                        this.state.programGeneral.totalArea
                                      }
                                      displayType={"text"}
                                      thousandSeparator={"."}
                                      decimalSeparator={","}
                                      decimalScale={0}
                                    />
                                  )}
                                </React.Fragment>
                              )}
                              &nbsp;
                              {this.state.programGeneral.totalArea > 10000 ? (
                                <>Ha</>
                              ) : (
                                <>
                                  m<sup>2</sup>
                                </>
                              )}
                            </h4>
                            <span>{t("TotalArea")}</span>
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon">
                            <img src={icon_tree} alt="Tree" />
                          </div>
                          <div className="text">
                            <h4>
                              {this.state.lang === "id" ? (
                                <NumberFormat
                                  value={this.state.programGeneral.totalTree}
                                  displayType={"text"}
                                  thousandSeparator={"."}
                                  decimalSeparator={","}
                                  decimalScale={0}
                                />
                              ) : (
                                <NumberFormat
                                  value={this.state.programGeneral.totalTree}
                                  displayType={"text"}
                                  thousandSeparator={","}
                                  decimalSeparator={"."}
                                  decimalScale={0}
                                />
                              )}{" "}
                              {t("Tree(s)")}
                            </h4>
                            <span>{t("TotalNumberOfTrees")}</span>
                          </div>
                        </div>
                        <div className="card-icon">
                          <div className="icon">
                            <img src={icon_jejak} alt="Sequestration" />
                          </div>
                          <div className="text">
                            <h4>
                              {SeparatorValue(
                                this.state.lang,
                                this.state.programGeneral
                                  .estimatedCarbonAbsorption * 1000000
                              )}
                              &nbsp;
                              {UnitValue(
                                this.state.lang,
                                this.state.programGeneral
                                  .estimatedCarbonAbsorption * 1000000
                              )}
                            </h4>
                            <span>{t("EstimatedCarbonStock")}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                    {this.state.cstock.lifespan < 4 ||
                    this.state.treeGrowthCarbon.length === 0 ? (
                      <></>
                    ) : (
                      <div className="col-sm-12">
                        <h3>{t("Programinsight")}</h3>
                        <div className="card card-white">
                          <h3 className="annual-title mb-3">
                            {t("Annualtreegrowth")}
                          </h3>
                          <div className="my-3">
                            <Tabs>
                              <TabList className="custom-tablist">
                                <Tab className="custom-tab annual">tCO2e</Tab>
                                <Tab className="custom-tab annual">
                                  Diameter
                                </Tab>
                              </TabList>

                              <TabPanel>
                                <div className="d-flex align-items-end justify-content-around background-annual mt-3">
                                  {treeGrowthCarbon
                                    .slice(0, 4)
                                    .concat(treeGrowthCarbon.slice(-1))
                                    .map((data, index) => {
                                      let iconSrc = "";

                                      if (index === 0) {
                                        iconSrc = data.active
                                          ? icon_2023
                                          : icon_2023_disabled;
                                      } else if (index === 1) {
                                        iconSrc = data.active
                                          ? icon_2024
                                          : icon_2024_disabled;
                                      } else if (index === 2) {
                                        iconSrc = data.active
                                          ? icon_2025
                                          : icon_2025_disabled;
                                      } else if (index === 3) {
                                        iconSrc = data.active
                                          ? icon_2026
                                          : icon_2026_disabled;
                                      } else {
                                        iconSrc = data.active
                                          ? icon_2030
                                          : icon_2030_disabled;
                                      }
                                      return (
                                        <div
                                          className="d-flex flex-column align-items-center justify-content-end"
                                          key={data.year}
                                        >
                                          <p className="value-annual-chart">
                                            {SeparatorValue(
                                              this.state.lang,
                                              data.carbonEmission * 1000000
                                            )}
                                            &nbsp;
                                            {UnitValue(
                                              this.state.lang,
                                              data.carbonEmission * 1000000
                                            )}
                                          </p>
                                          <img src={iconSrc} alt="img" />
                                          <p
                                            style={{
                                              fontSize: "10px",
                                              color: "#A3A3A3",
                                            }}
                                          >
                                            {index === 4 ? (
                                              <span>{t("Targetin")}</span>
                                            ) : (
                                              ""
                                            )}
                                            <span> {data.year}</span>
                                          </p>
                                        </div>
                                      );
                                    })}
                                </div>
                              </TabPanel>
                              <TabPanel>
                                <div className="d-flex align-items-end justify-content-around background-annual mt-3">
                                  {treeGrowth
                                    .slice(0, 4)
                                    .concat(treeGrowth.slice(-1))
                                    .map((data, index) => {
                                      let iconSrc = "";

                                      if (index === 0) {
                                        iconSrc = data.active
                                          ? icon_2023
                                          : icon_2023_disabled;
                                      } else if (index === 1) {
                                        iconSrc = data.active
                                          ? icon_2024
                                          : icon_2024_disabled;
                                      } else if (index === 2) {
                                        iconSrc = data.active
                                          ? icon_2025
                                          : icon_2025_disabled;
                                      } else if (index === 3) {
                                        iconSrc = data.active
                                          ? icon_2026
                                          : icon_2026_disabled;
                                      } else {
                                        iconSrc = data.active
                                          ? icon_2030
                                          : icon_2030_disabled;
                                      }
                                      return (
                                        <div
                                          className="d-flex flex-column align-items-center justify-content-end"
                                          key={data.year}
                                        >
                                          <p className="value-annual-chart">
                                            {SeparatorNumber(
                                              this.state.lang,
                                              data.diameter,
                                              1
                                            )}{" "}
                                            cm
                                          </p>
                                          <img src={iconSrc} alt="img" />
                                          <p
                                            style={{
                                              fontSize: "10px",
                                              color: "#A3A3A3",
                                            }}
                                          >
                                            {index === 4 ? (
                                              <span>{t("Targetin")}</span>
                                            ) : (
                                              ""
                                            )}
                                            <span> {data.year}</span>
                                          </p>
                                        </div>
                                      );
                                    })}
                                </div>
                              </TabPanel>
                            </Tabs>
                          </div>
                        </div>
                      </div>
                    )}
                    {this.state.loadingMap === true ? null : (
                      <div className="col-sm-12">
                        <h3>{t("ProgramArea")}</h3>
                        {this.state.blockProgram ? (
                          <ProgramMapArea
                            program={this.state.programid}
                            user={this.state.userid}
                            block={this.state.blockProgram}
                            blockName={this.state.blockProgramName}
                            blockArea={this.state.blockArea}
                            drone={this.state.droneId}
                            //droneSummary={this.state.droneSummary}
                          />
                        ) : null}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </Translation>
          )}
        </div>
      </>
    );
  }
}

export default ProfileProgramContributionAdoption;
